import { render, staticRenderFns } from "./authorize-instagram.vue?vue&type=template&id=49a9b736&scoped=true&"
import script from "./authorize-instagram.vue?vue&type=script&lang=js&"
export * from "./authorize-instagram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a9b736",
  null
  
)

export default component.exports